
        var result = require("!!../../../../../node_modules/css-loader/index.js!./cotwo-overview.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/cotwo/cotwo-overview/cotwo-overview.component.css
// module id = 638
// module chunks = 0